// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__1quMw","list":"PatternAutocomplete_list__2MoYi"};